import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import get from 'lodash.get';
import ListAvatar from '../atom/list-avatar';
import styled from 'styled-components';
import { Flex, Box } from '@rebass/grid';

const ListItemContainer = styled.div`
  width: 100%;
`;

const UserListItem = ({ style = {}, user, children, handleClick }) => {
  const avatarUrl = get(user, 'avatar_url');
  const isClickable = typeof handleClick === 'function';
  return (
    <ListItemContainer>
      <ListItem
        style={{
          cursor: 'pointer',
          ...style,
        }}
        onClick={isClickable ? () => handleClick(user) : undefined}
      >
        <Flex alignItems="center" justifyContent="space-between" width="100%">
          <Flex>
            <ListItemAvatar>
              <ListAvatar
                style={{
                  ...style.img,
                }}
                src={avatarUrl}
                name={get(user, 'name')}
              />
            </ListItemAvatar>
            <ListItemText>{user.name}</ListItemText>
          </Flex>
          {/* Keep controls in the right-hand slot from triggering the row click */}
          <Box onClick={isClickable ? (e) => e.stopPropagation() : undefined}>
            {children}
          </Box>
        </Flex>
      </ListItem>
    </ListItemContainer>
  );
};

export default UserListItem;
